<template>
  <el-form
    :model="accessNginxForm"
    :rules="accessNginxRules"
    ref="accessNginxForm"
    label-width="160px"
    :inline-message="true"
    class="access-nginx-form rule-form"
  >
    <div class="access-nginx-form-pattern">
      <el-form-item class="form-tip-top" prop="pattern" label="NGINX 日志配置：">
        <el-input
          v-model="accessNginxForm.pattern"
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入 NGINX 日志配置"
          :disabled="formType === 'SHOW'"
        >
        </el-input>

        <el-button
          v-if="formType !== 'SHOW'"
          class="pattern-btn"
          type="primary"
          @click="onParseNginx"
          >测试</el-button
        >
      </el-form-item>
      <el-form-item>
        <p class="error-tip" v-if="!!errorTip">{{ errorTip }}</p>
        <p class="form-tip">
          请贴入需要解析的 NGINX
          日志配置，注意日志配置的格式，变量间只能添加一个空格。例如：log_format main '$remote_addr
          - $remote_user [$time_local] "$request" $http_host' '$status $request_length
          $body_bytes_sent "$http_referer"' '"$http_user_agent" $request_time
          $upstream_response_time';
        </p>
      </el-form-item>
      <el-form-item
        v-for="(result, index) in accessNginxForm.results"
        :prop="`results[${index}].key`"
        :key="index"
        :rules="accessNginxRules.results"
      >
        <span slot="label" v-if="index === 0"> 提取结果：</span>
        <el-col v-if="result" :span="12" style="padding-left: 0;">
          <el-input :title="result.key" v-model="result.key" disabled></el-input>
        </el-col>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import Validator from '../../../../utils/Validator';

export default {
  name: 'AccessNginxRuleCreator',

  props: {
    accessConfigForm: {
      type: Object
    },
    formType: {
      type: String
    }
  },

  data() {
    const validatorRequired = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.required()).validate();
    };

    const validatorStandardStr = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator
        .register(validator.isNoSpace())
        .register(validator.isStandardStr())
        .validate();
    };

    const validatorLength = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.lenRange(50)).validate();
    };

    const validatorNginx = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.isStandardNginx()).validate();
    };

    return {
      errorTip: '',
      accessNginxForm: {
        pattern: '',
        results: [
          {
            key: '',
            value: ''
          }
        ]
      },
      accessNginxRules: {
        pattern: [
          { required: true, message: '请输入 NGINX 日志配置', trigger: 'blur' },
          { validator: validatorRequired, message: '请输入 NGINX 日志配置', trigger: 'blur' },
          { validator: validatorNginx, trigger: 'blur' }
        ],
        results: [
          {
            required: true,
            message: 'key 不能为空',
            trigger: 'change'
          },
          { validator: validatorRequired, message: 'key 不能为空', trigger: ['blur', 'change'] },
          { validator: validatorStandardStr, trigger: 'blur' },
          { validator: validatorLength, trigger: 'blur' }
        ]
      }
    };
  },

  created() {
    this.getData();
  },

  methods: {
    /**
     * 本地存储数据，用来步骤切换时回显数据
     */
    getData() {
      this.accessNginxForm = {
        pattern: this.accessConfigForm.pattern,
        results: this.accessConfigForm.results
      };
    },
    /**
     * Nginx 解析
     */
    onParseNginx() {
      this.accessNginxForm.results = [
        {
          key: ''
        }
      ];

      try {
        const reg = /\$[a-zA-Z_]+/g;
        const nginxObj = this.accessNginxForm.pattern.match(reg);

        this.accessNginxForm.results = Object.keys(nginxObj).map(item => ({
          key: nginxObj[item] ? nginxObj[item].replace('$', '') : ''
        }));

        this.accessNginxForm.results.map((item, index) => {
          if (item.key === 'request') {
            this.accessNginxForm.results.splice(
              index,
              1,
              {
                key: 'request_method'
              },
              {
                key: 'request_uri'
              }
            );
          }
        });

        // 解析出结果，去掉错误提示
        if (this.accessNginxForm.results[0].key) {
          this.errorTip.nginx = '';
        }
      } catch (e) {
        this.$refs.accessNginxForm.validateField('pattern', e => {
          // 表单校验成功，但是没有解析出结果
          if (!e && !this.accessNginxForm.results[0].key) {
            this.errorTip = 'NGINX 日志配置格式不正确';
          } else {
            this.errorTip = '';
          }
        });
      }
    },
    onSaveData() {
      return this.accessNginxForm;
    },
    /**
     * 提交验证
     */
    onValidate() {
      return this.$refs.accessNginxForm.validate();
    }
  }
};
</script>

<style lang="scss" scoped>
.access-nginx-form {
  &-pattern {
    position: relative;

    .pattern-btn {
      position: absolute;
      top: 0;
      right: 0;
      transform: translateX(110%);
    }
  }
}
</style>
